import withStyles from '@mui/styles/withStyles';
import { Button } from '@mui/material';

const SuccessButtonComponent = withStyles({
  root: {
    boxShadow: 'none',
    color: 'white',
    backgroundColor: 'green',
  },
  contained: {
    boxShadow: 'none',
    color: 'white',
    fontWeight: 700,
    backgroundColor: '#5CC257',
    '&:hover': {
      backgroundColor: 'green',
    },
  },
})(Button);

export default SuccessButtonComponent;
